<template>
  <div id="app-receipt">
    <div class="flex mb-6 gap-2">
      <v-icon color="primary">
        mdi-file-outline
      </v-icon>
      <span class="text-xl font-medium text-primary">{{ $t('papers.header') }}</span>
      <!-- <new-paper type="button" /> -->
    </div>
    <div class="d-flex flex-wrap">
      <div
        class="mr-6 mb-6">
        <NewPaper type="card" />
      </div>
      <div
        v-for="(item) in paperGroupList.nodes"
        :key="`card-receipt-${item.id}`"
        class="mr-6 mb-6">
        <PaperCard
          :item-id="item.id"
          :inner-height="item.height"
          :inner-width="item.width"
          :paper-size="item.paperSize"
          :canvas="item.canvas || []"
          :margin="item.margin"
          @removed="refetch()" />
        <v-tooltip
          :disabled="item.name.length < 16"
          bottom>
          <template #activator="{ on, attrs }">
            <div
              v-bind="attrs"
              class="mt-2 paper-name font-weight-medium secondary--text paper-name-caption text-overflow"
              v-on="on">
              {{ item.name }}
            </div>
          </template>
          <v-card
            max-width="240"
            color="transparent"
            flat
            dark>
            {{ item.name }}
          </v-card>
        </v-tooltip>
      </div>
    </div>
    <snt-pagination
      v-model="page"
      :total-pages="paperGroupList.pagesCount" />
  </div>
</template>

<script>
import { GET_PAPERGROUPS } from '@/resources/graphql'
import NewPaper from './components/NewPaper.vue'
import PaperCard from './components/PaperCard.vue'

export default {
  name: 'Papers',
  components: {
    NewPaper,
    PaperCard
  },
  apollo: {
    paperGroupList: {
      fetchPolicy: 'network-only',
      query: GET_PAPERGROUPS,
      variables () {
        return {
          page: this.page,
          perPage: 9,
          sort: 'id_DESC'
        }
      }
    }
  },
  data () {
    return {
      page: 1,
      paperGroupList: {
        pagesCount: 0,
        nodes: []
      }
    }
  },
  methods: {
    refetch () {
      this.$apollo.queries.paperGroupList.refetch()
    }
  }
}
</script>

<style scoped>
  .paper-name {
    width: 180px;
  }
  .paper-name-caption {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: pre-line;
  }
</style>
